import { ReactNode, useEffect } from "react";
import { SidebarInset, SidebarProvider } from "../ui/sidebar";
import AppSidebar from "./app-sidebar";
import { toast, Toaster } from "sonner";
import { router } from "@inertiajs/react";
import MetaTags from "./meta-tags";

export default function Layout({ children }: { children: ReactNode }) {
  useEffect(() => {
    return router.on("flash", (event) => {
      const flash = event.detail.flash;

      if (flash["authorization_error"]) {
        toast.error(flash["authorization_error"]);
      }
    });
  }, []);

  return (
    <>
      <MetaTags />
      <SidebarProvider>
        <AppSidebar />
        <SidebarInset>
          <div className="@container/main flex flex-1 flex-col gap-8 p-6 pb-12">
            {children}
          </div>
        </SidebarInset>
        <Toaster position="top-center" />
      </SidebarProvider>
    </>
  );
}
